function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { isAllSwagCategory } from '../../../../../../../redux/product-listing/product-listing.utils';
import collapseAnimationClasses from './collapse.anim.scss';
import { Checkbox } from './checkbox';
import { isAnyItemIsTooLong } from './checkbox.utils';
import classes from './checkbox-section.scss';
export const CheckboxSection = ({
  filterData,
  selectedFilter,
  onClickCheckbox,
  dataInput,
  isDisabled,
  color,
  type
}) => {
  const [selected, setSelected] = useState({});
  const parentIds = filterData.map(filter => filter.id);
  useEffect(() => {
    if (!selectedFilter) {
      setSelected({});
      return;
    }
    const newSelected = selectedFilter.reduce((acc, id) => {
      if (parentIds.includes(id)) {
        acc[id] = [];
      }
      return acc;
    }, {});
    selectedFilter.forEach(id => {
      if (parentIds.includes(id)) {
        return;
      }
      const parent = filterData.find(filter => {
        return filter.children && filter.children.some(childFilter => childFilter.id === id);
      });
      if (!parent) {
        return;
      }
      if (!newSelected[parent.id]) {
        newSelected[parent.id] = [];
      }
      newSelected[parent.id].push(id);
    });
    setSelected(newSelected);
  }, [selectedFilter, filterData]);
  const onParentCheckboxClick = id => {
    const newSelected = _objectSpread({}, selected);
    if (selected[id]) {
      const valuesToDelete = selected[id];
      delete newSelected[id];
      if (valuesToDelete && valuesToDelete.length > 0) {
        onClickCheckbox(null, [id, ...valuesToDelete]);
      } else {
        onClickCheckbox(id);
      }
      return setSelected(newSelected);
    }
    newSelected[id] = [];
    onClickCheckbox(id);
    setSelected(newSelected);
  };
  const onChildCheckboxClick = (id, parentId) => {
    const newSelected = _objectSpread({}, selected);
    if (!newSelected[parentId].includes(id)) {
      newSelected[parentId].push(id);
      onClickCheckbox(id, [parentId]);
      return setSelected(newSelected);
    }
    if (newSelected[parentId].includes(id) && newSelected[parentId].length === 1) {
      newSelected[parentId] = [];
      onClickCheckbox(parentId, [id]);
      return setSelected(newSelected);
    }
    if (newSelected[parentId].includes(id) && newSelected[parentId].length > 1) {
      newSelected[parentId] = newSelected[parentId].filter(selectedId => selectedId !== id);
      onClickCheckbox(id, [parentId]);
      return setSelected(newSelected);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [classes.threePerRow]: !isAnyItemIsTooLong(filterData) && !isAllSwagCategory()
    }),
    "data-attributes-filter": dataInput
  }, /*#__PURE__*/React.createElement(TransitionGroup, null, filterData.map(({
    children,
    id,
    name,
    count
  }) => {
    const isExpanded = Boolean(children && (children === null || children === void 0 ? void 0 : children.length) && selected[id]);
    const animationClassNames = _objectSpread({}, collapseAnimationClasses, {
      enterActive: isExpanded ? collapseAnimationClasses.enterActiveExpanded : collapseAnimationClasses.enterActive,
      exit: isExpanded ? collapseAnimationClasses.exitExpanded : collapseAnimationClasses.exit
    });
    return /*#__PURE__*/React.createElement(CSSTransition, {
      timeout: 300,
      classNames: animationClassNames,
      key: name
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
      color: color,
      id: id,
      count: count,
      name: name,
      type: type,
      dataInput: dataInput,
      isSelected: selected[id],
      isDisabled: isDisabled,
      onClickCheckbox: onParentCheckboxClick
    }), isExpanded && /*#__PURE__*/React.createElement("div", {
      className: classes.childCheckboxSection
    }, children === null || children === void 0 ? void 0 : children.map(child => {
      var _selected$id;
      return /*#__PURE__*/React.createElement(Checkbox, {
        key: child.name,
        color: color,
        id: child.id,
        count: child.count,
        name: child.name,
        type: type,
        dataInput: dataInput,
        isSelected: (_selected$id = selected[id]) === null || _selected$id === void 0 ? void 0 : _selected$id.includes(child.id),
        isDisabled: isDisabled,
        onClickCheckbox: childId => onChildCheckboxClick(childId, id)
      });
    }))));
  })));
};